import { of as observableOf } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { StatutService } from './statut.service';
import { AlertService } from '../alert/alert.service';

@Injectable()
export class AppStatusResolver {
	constructor(private statutService: StatutService, private alertService: AlertService) {
	}

	resolve() {
		return this.statutService.getApplicationStatus().pipe(
			catchError(error => {
				this.alertService.error(error.error);
				return observableOf(null);
			}));
	}
}
